NS('fishersci.components').CartMobileCheckoutModal = (function() {
    var mobileCheckoutModal,
        mobileCheckoutModalContent,
        isDragging,
        hidingModal,
        startY,
        startHeight,
        mainCart,
        mobileCheckoutModalHeader,
        mobileCheckoutCloseButton,
        mobileCheckoutModalPopoutHeader,
        dragIcon,
        hideableCheckoutButton,
        checkoutWrapper,
        orderTotal
    ;
    return {
        /**
         * Initialize Mobile Checkout Modal
         * initializes the mobile checkout modal and its event listeners
         * modal exists for ~480px and below screen width
         * @return {undefined}
         */
        init: function () {
            console.log('Mobile Checkout Modal init');

            // Modal DOM elements
            mobileCheckoutModal = document.querySelector(".mobile-checkout-modal");
            mainCart = document.querySelector(".main-cart-section");
            mobileCheckoutModalContent = mobileCheckoutModal.querySelector(".mobile-checkout-modal-content");
            dragIcon = mobileCheckoutModal.querySelector(".drag-icon")
            mobileCheckoutModalHeader = mobileCheckoutModal.querySelector(".mobile-checkout-modal-header");
            mobileCheckoutCloseButton = mobileCheckoutModal.querySelector(".close-modal-icon");
            mobileCheckoutModalPopoutHeader = mobileCheckoutModal.querySelector(".mobile-checkout-modal-popout-header");
            checkoutWrapper = mobileCheckoutModal.querySelector(".js-checkout-button-wrapper");
            orderTotal = mobileCheckoutModal.querySelector(".order-total");
            hideableCheckoutButton = mobileCheckoutModal.querySelector(".hideable-checkout-button");

            // Global variables for tracking drag events
            isDragging = false, startY, startHeight;
            hidingModal = false;

            function updateSheetHeight(height) {
                mobileCheckoutModalContent.style.height = height + 'vh';
                mobileCheckoutModalContent.style.pointerEvents = "auto";
                mobileCheckoutModal.classList.toggle("fullscreen", height === 60);
            }

            /**
             * Hides the Mobile Checkout Modal
             * Returns to default state of the modal like when the showMobileCheckoutModal function is called
             */
            function hideMobileCheckoutModal(){
                hidingModal = false;
                updateSheetHeight(15);
                mobileCheckoutCloseButton.classList.add("hide")
                mobileCheckoutModalPopoutHeader.classList.add("hide")
                checkoutWrapper.classList.add("hide")
                orderTotal.classList.remove("hide")
                hideableCheckoutButton.classList.remove("hide")
                setTimeout(function () {
                    hidingModal = false;
                }, 1000);
            }

            /**
             * 'Pops out' the Mobile Checkout Modal
             * Expands modal to show the user more information about their order summary
             */
            function  popOutModal() {
                if (hidingModal){ //hide the modal if the user taps the header while it's expanded
                    hideMobileCheckoutModal();
                    return;
                }
                mobileCheckoutCloseButton.classList.remove("hide")
                mobileCheckoutModalPopoutHeader.classList.remove("hide")
                checkoutWrapper.classList.remove("hide")
                orderTotal.classList.add("hide")
                hideableCheckoutButton.classList.add("hide")
                hidingModal = true;
                var modalHeight = 50;
                if($('#zipCodeContainer').length > 0){ // we need to increase the height of the modal if the zip code container is visible
                    modalHeight = 55;
                }
                updateSheetHeight(modalHeight);
            }

            /**
             * 'Shows' the Mobile Checkout Modal
             * Displays the minimized version of the modal
             */
            function showMobileCheckoutModal() {
                mobileCheckoutModal.classList.add("show");
                document.body.style.overflowY = "hidden";
                updateSheetHeight(15);
            }

            $(document).ready(function () {
                if($(window).width() < 640) { //Mobile Dynamic Resizing
                    showMobileCheckoutModal()
                }
            });

            mobileCheckoutModalHeader.addEventListener("touchstart", popOutModal);
            mobileCheckoutCloseButton.addEventListener("touchstart", hideMobileCheckoutModal);
            mainCart.addEventListener("touchstart", hideMobileCheckoutModal);
            dragIcon.addEventListener("touchstart", hideMobileCheckoutModal);
        },

    //     $(window).resize(function () {
    //         resize();
    //     });
    //
    // function resize() {
    //     if ($(window).width() < 480) { //Mobile Dynamic Resizing
    //         showMobileCheckoutModal()
    //     } else if ($(window).width() < 991 && $(window).width() > 767) { //Tablet Dynamic Resizing
    //         //
    //     } else { //Desktop
    //         //
    //     }
    // }


    }

}());




    /* EXTRA functions for if we ever want the user to be able to drag the modal instead of pop out
        //
        mobileCheckoutModalHeader.addEventListener("mousedown", dragStart);
        document.addEventListener("mousemove", dragging);
        document.addEventListener("mouseup", dragStop);
        document.addEventListener("touchmove", dragging);
        document.addEventListener("touchend", dragStop);
        mainCart.addEventListener("click", hideMobileCheckoutModal);

        //
        function dragStart(e) {
            isDragging = true;
            startY = e.pageY || (e.touches && e.touches[0].pageY);
            startHeight = parseInt(mobileCheckoutModalContent.style.height);
            mobileCheckoutModal.classList.add("dragging");
        }

        //
        function dragging(e) {
            if (!isDragging) return;
            const delta = startY - (e.pageY || (e.touches && e.touches[0].pageY));
            const newHeight = startHeight + delta / window.innerHeight * 80;
            updateSheetHeight(newHeight);
        }

        //
        function dragStop() {
            isDragging = false;
            mobileCheckoutModal.classList.remove("dragging");
            const sheetHeight = parseInt(mobileCheckoutModalContent.style.height);
            if (sheetHeight < 25) {
                // hideMobileCheckoutModal();
            } else if (sheetHeight > 55) {
                updateSheetHeight(80);
            } else {
                updateSheetHeight(30);
            }
        }*/

